import privacy from '../commonAssets/beemPrivacyText';
import deleteAccountText from '../commonAssets/deleteAccountText';
import terms from '../commonAssets/termsText';
import chatLogo from './assets/chat_logo.svg';
import opIcon from './assets/dtg-op-icon.svg';
import favicon from './assets/favicon.svg';
import imprint from './assets/imprintText';
import logo from './assets/logo.svg';
import simpleLogo from './assets/simple_logo.svg';

const config = {
  title: 'DTG BEEM',
  description:
    'Mit der Chat-Plattform BEEM stellen Fachhandwerker ihrem DTG-Kontakt rechtssicher Fragen. Immer schnell und einfach!',
  identifier: 'dtg',
  appName: 'DTG',
  defaultBrand: 'DTG',
  url: 'dtgbeem.de',
  apiBaseUrl: 'https://api.dtgbeem.de',
  helpUrl: 'https://hilfe.getbeem.de/',
  iosStoreUrl: 'https://apps.apple.com/us/app/dtg-beem/id1633652766',
  androidStoreUrl: 'https://play.google.com/store/apps/details?id=de.dtgbeem',
  supportEmail: 'support@getbeem.de',
  favicon,
  logo,
  chatLogo,
  simpleLogo,
  packageId: 'de.dtgbeem',
  privacyText: privacy,
  termsText: terms,
  usercentricsId: 'RyqGliTaz',
  imprintText: imprint,
  deleteAccountText,
  welcomeText: 'Willkommen bei DTG BEEM!',
  identifierPlaceholder: 'Mobilnummer oder E-Mail Adresse',
  mainText: 'Bitte geben Sie Ihre Mobilnummer oder E-Mail Adresse ein, um sich anzumelden.',
  opIcon,
};

export default config;
